import { useState } from "react";
import { Minus, Plus, Trash2, Lock } from "lucide-react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { api, euro, imgUrl, formatErr } from "@/lib/api";

export default function CartDrawer() {
  const { items, open, setOpen, setQty, remove, total, clear } = useCart();
  const [loading, setLoading] = useState(false);

  const checkout = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        items: items.map((i) => ({ product_id: i.id, quantity: i.quantity })),
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatErr(e));
      setLoading(false);
    }
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="bg-[#0F0F12] border-l border-red-900/40 text-white w-full sm:max-w-md flex flex-col" data-testid="cart-drawer">
        <SheetHeader>
          <SheetTitle className="tms-title text-4xl text-white">Carrello</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto mt-6 space-y-4">
          {items.length === 0 && <p className="text-zinc-500 text-sm" data-testid="cart-empty">Il carrello è vuoto.</p>}
          {items.map((i) => (
            <div key={i.id} className="flex gap-3 border border-zinc-800 p-3" data-testid={`cart-item-${i.id}`}>
              <img src={imgUrl(i.image_url)} alt="" className="w-20 h-20 object-cover" />
              <div className="flex-1 min-w-0">
                <p className="font-display italic font-bold uppercase leading-tight">{i.name}</p>
                <p className="text-red-500 font-bold text-sm mt-1">{euro(i.price)}</p>
                <div className="flex items-center gap-2 mt-2">
                  <button className="p-1 border border-zinc-700 hover:border-red-600" onClick={() => setQty(i.id, i.quantity - 1)} data-testid={`cart-item-decrease-${i.id}`}><Minus size={12} /></button>
                  <span className="w-6 text-center text-sm" data-testid={`cart-item-qty-${i.id}`}>{i.quantity}</span>
                  <button className="p-1 border border-zinc-700 hover:border-red-600" onClick={() => setQty(i.id, i.quantity + 1)} data-testid={`cart-item-increase-${i.id}`}><Plus size={12} /></button>
                  <button className="ml-auto text-zinc-500 hover:text-red-500" onClick={() => remove(i.id)} data-testid={`cart-item-remove-${i.id}`}><Trash2 size={16} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-zinc-800 pt-5 space-y-4">
            <div className="flex justify-between items-end">
              <span className="text-xs uppercase tracking-[0.2em] text-zinc-400">Totale (IVA incl.)</span>
              <span className="font-display italic font-black text-3xl text-red-500" data-testid="cart-total">{euro(total)}</span>
            </div>
            <button className="btn-red w-full" onClick={checkout} disabled={loading} data-testid="cart-checkout-button">
              <Lock size={16} /> {loading ? "Reindirizzamento…" : "Paga con Stripe"}
            </button>
            <button className="w-full text-xs text-zinc-500 hover:text-white uppercase tracking-widest" onClick={clear} data-testid="cart-clear-button">Svuota carrello</button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
